export { FocusAreaHeader } from './FocusAreaHeader';
